import { render } from "./ReportTotalsByBucketSize.vue?vue&type=template&id=6a5ba45e&scoped=true"
import script from "./ReportTotalsByBucketSize.vue?vue&type=script&lang=js"
export * from "./ReportTotalsByBucketSize.vue?vue&type=script&lang=js"

import "./ReportTotalsByBucketSize.vue?vue&type=style&index=0&id=6a5ba45e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5ba45e"]])

export default __exports__